import { render } from "./FormError.vue?vue&type=template&id=6fdd3832&scoped=true"
import script from "./FormError.vue?vue&type=script&lang=js"
export * from "./FormError.vue?vue&type=script&lang=js"

import "./FormError.vue?vue&type=style&index=0&id=6fdd3832&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdd3832"]])

export default __exports__